import React from 'react';
import { Link, Navigate } from 'react-router-dom';
import './CollegeDashboard.css';
import { useLocation, useNavigate } from 'react-router-dom';
import Header from '../../../Registration/Header';
import user from '../../../../Constant/Icons/user.svg';
import axios from 'axios';
import { useState } from 'react';
import { serverUrl } from '../../../../Constant/Static/config';
import PopModal from '../../../../Constant/Custom/Models/PopModal';

const AllotmentList = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalType, setModalType] = useState({ title: '', text: '', icon: '' });

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);
  const navigate = useNavigate();
  const CollegeName = sessionStorage.getItem('CollegeName');

  const Collegecode = sessionStorage.getItem('collegeCode')
  if (!CollegeName && !Collegecode) {
    navigate('/college-login')
  }


  const allotmentItems = [
    { label: 'Special Counselling', endpoint: '/api/college/generate-pdf', type: 'allotment' },
    { label: 'Vacancy Position Special', endpoint: '/api/college/generate-pdf', type: 'vacancy' },
    { label: 'Round-1', endpoint: '/api/college/generate-pdf', type: 'round1allotment' },
    { label: 'Vacancy Position Round1', endpoint: '/api/college/generate-pdf', type: 'vacancy_round1' },
    // { label: 'Round-2', endpoint: '/api/college/generate-pdf', type: 'round2allotment' },
    // { label: 'Round-3', endpoint: '/api/college/generate-pdf', type: 'round3allotment' },
    // { label: 'SCA against Sc', endpoint: '/api/college/generate-pdf', type: 'scascallotment' },
    // { label: 'B.Sc', endpoint: '/api/college/generate-pdf', type: 'bscallotment' },
    // { label: 'supplementary counselling', endpoint: '/api/college/generate-pdf', type: 'sup' },
    // { label: 'supplementary counselling Bsc', endpoint: '/api/college/generate-pdf', type: 'supbsc' },
    
  ];


  const handleDownload = async (endpoint, label, type) => {
    try {
      const response = await axios.post(
        `${serverUrl}/api/college/generate-pdf`,
        {
          collname: CollegeName,
          collegeCode: Collegecode,
          type: type,
        },
        {
          responseType: 'blob',
        }
      );

      

      if (response.headers['content-type'].includes("application/json")) {
        const text = await response.data.text();
        const json = JSON.parse(text);

        if( json.message == "no_allot_list"){
          setModalType({
            icon: 'warning',
            title: 'Invalid',
            text: 'students not alloted in this round',
          });
          openModal();
        }
      }
      else {
        const blob = response.data;
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `${label.replace(/\s+/g, '_').toLowerCase()}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.error('Error downloading PDF:', error);

      if (error.response) {

        console.error('Server error:', error.response.status, error.response.data);
        alert(`Failed to download PDF for ${label}. Server responded with status ${error.response.status}.`);
      } else if (error.request) {

        console.error('No response received:', error.request);
        alert(`Failed to download PDF for ${label}. No response from server (possible network or CORS issue).`);
      } else {

        console.error('Client-side error:', error.message);
        alert(`Failed to download PDF for ${label}. Error: ${error.message}`);
      }
    }
  };
  const handleCancel = () => {

    closeModal();
  };

  return (
    <div>
      <Header>
        <Link to="/college-login">
          <img src={user} alt="Login" width={50} height={50} />
        </Link>
      </Header>
      <div className="allotment-container">


        <div className="allotment-header">
          <h3 className="allotment-header-title">VACANCY POSITION AND ALLOTMENT LIST</h3>
          <h4 className="allotment-header-subtitle">
            {Collegecode}-{CollegeName}

          </h4>
        </div>


        <div className="allotment-table-container">
          <table className="allotment-table allotment-table-bordered allotment-table-striped allotment-table-centered">

            <tbody>
              {allotmentItems.map((item, index) => (
                <tr key={index}>
                  <td>{item.label}</td>
                  <td>
                    <button
                      className={`allotment-btn allotment-btn-md allotment-btn-icon ${item.type === 'allotment' ? 'allotment-btn-danger' : 'allotment-btn-primary'}`}
                      onClick={() => handleDownload(item.endpoint, item.label, item.type)}
                    >
                      <span className="allotment-icon">↓</span>
                      Download
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <PopModal
          isOpen={isModalOpen}
          type={modalType}
          confirmButtonText="OK"
          onConfirm={handleCancel}
        />
      </div>
    </div>
  );
};

export default AllotmentList;